const KEY = "bookswap_location";

export type Coords = { lat: number; lng: number };

export function getStoredLocation(): Coords | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Coords) : null;
  } catch { return null; }
}

export function storeLocation(c: Coords) {
  localStorage.setItem(KEY, JSON.stringify(c));
}

export function requestLocation(): Promise<Coords> {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) return reject(new Error("Geolocation not supported"));
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const c = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        storeLocation(c);
        resolve(c);
      },
      (err) => reject(err),
      { enableHighAccuracy: false, timeout: 10000 },
    );
  });
}
